import React from 'react';

import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

import type { AlertProps } from '@mui/material/Alert';

const styles = {
  alertBg: {
    '& .MuiAlert-icon': {
      color: '#BD0017'
    },
    backgroundColor: '#FFEBEB',
    border: '1px solid #BD0017',
    color: '#BD0017',
    fontSize: '14px'
  },
  infoBg: {
    '& .MuiAlert-icon': {
      color: '#0A7EBF'
    },
    backgroundColor: '#EBFAFF',
    border: '1px solid #0A7EBF',
    color: '#0A7EBF',
    fontSize: '14px'
  }
};

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MuiAlert sx={styles.alertBg} ref={ref} {...props} />
));

const Info = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MuiAlert sx={styles.infoBg} ref={ref} {...props} />
));

type SnackbarProps = React.ComponentProps<typeof Snackbar>;

type Props = SnackbarProps & {
  text: string;
  infoText?: string;
  closeButton?: () => void;
};

const CustomSnackbar: React.FC<Props> = (props) => {
  const { text, infoText, closeButton, ...rest } = props;

  return (
    <>
      {text && (
        <Snackbar {...rest}>
          <Alert
            severity="error"
            {...(closeButton && { onClose: closeButton })}
          >
            {text}
          </Alert>
        </Snackbar>
      )}
      {infoText && (
        <Snackbar {...rest}>
          <Info severity="info" {...(closeButton && { onClose: closeButton })}>
            {infoText}
          </Info>
        </Snackbar>
      )}
    </>
  );
};

export default CustomSnackbar;
